import {
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  Output
} from "@angular/core";
import {
  fromEvent,
  merge,
  of,
  Subscription,
  timer,
  debounceTime
} from "rxjs";
import {
  map,
  switchMap,
  takeUntil,
  take,
  filter
} from "rxjs/operators";
import { AppService } from "../services/app.service";

@Directive({
  selector: "[longPress]"
})
export class LongPressDirective implements OnDestroy {
  private eventSubscribe: Subscription;
  threshold = 500;

  @Output()
  mouseLongPress = new EventEmitter<ElementRef<any>>();

  constructor(private elementRef: ElementRef, private appService: AppService) {
    const mousedown = fromEvent<MouseEvent>(elementRef.nativeElement, "mousedown").pipe(
      map(() => true)
    );

    const touchstart = fromEvent(elementRef.nativeElement, 'touchstart').pipe(map(() => true));

    const touchEnd = fromEvent(elementRef.nativeElement, 'touchend').pipe(map(() => false));

    const mouseup = fromEvent<MouseEvent>(window, "mouseup").pipe(
      map(() => false)
    );

    let hasNotifyed: boolean = false;

    this.eventSubscribe = merge(mousedown, mouseup, touchstart, touchEnd)
      .pipe(
        switchMap(state => {
          if (!state)
            hasNotifyed = false;

          return state ? timer(this.threshold, this.threshold).pipe((takeUntil(this.appService.onMouseMove$))) : of(null)
        }
        ), filter((value) => !!value)
      )
      .subscribe(() => {
        if (hasNotifyed) return;
        this.mouseLongPress.emit(elementRef.nativeElement)
        hasNotifyed = true;
      });
  }

  ngOnDestroy(): void {
    if (this.eventSubscribe) {
      this.eventSubscribe.unsubscribe();
    }
  }
}